module.exports = __webpack_public_path__ + "img/BA472D_CA6E67_C76150_CA6C59-256px.686d62d1.png";